import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { ROOT_API } from "../api/config";
import { useSelector, useDispatch } from "react-redux";
import {
  clearUserInformation,
  updateUserInformation,
} from "../stores/users/userSlice";

function Protected({ children, path }) {
  const user = useSelector((state) => state.user);
  const accessToken = localStorage.getItem("access_token");
  const [isSignedIn, setIsSignedIn] = useState(Boolean(accessToken));
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const getUserInformation = async () => {
      if (!accessToken) {
        dispatch(clearUserInformation());
        setIsSignedIn(false);
        setIsLoading(false);
        return;
      }

      const axiosObject = axios.create({
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      try {
        const res = await axiosObject.get(`${ROOT_API}apis/user/me`);
        if (res && res.data) {
          setIsSignedIn(true);
          dispatch(updateUserInformation(res.data.data));
        }
      } catch (error) {
        localStorage.removeItem("access_token");
        dispatch(clearUserInformation());
        setIsSignedIn(false);
      }
      setIsLoading(false);
    };

    getUserInformation();
  }, [accessToken, dispatch]);

  if (isLoading) {
    return <div className="protected-loading">Provjera prijave…</div>;
  }

  if (!isSignedIn) {
    return <Navigate to="/login" replace />;
  }
  if (path === "admin" && user.role !== "admin") {
    return <Navigate to="/login" replace />;
  }

  return children;
}
export default Protected;
